import React from 'react';
import { toAbsoluteUrl } from '@/utils';
import { Link } from "react-router-dom";

interface NoJobsContentProps {
    // No props needed
}

const NoJobsContent: React.FC<NoJobsContentProps> = () => {
    return (
        <div className="grid lg:grid-cols-3 gap-5 lg:gap-7.5">
            <div className="lg:col-span-3">
                <div className="mb-7.5">
                    <div className="card">
                        <div className="card-body px-10 py-7.5 lg:pr-12.5 flex flex-col justify-start">
                            <div className="flex flex-wrap md:flex-nowrap items-start gap-6 md:gap-10">
                                <div className="flex flex-col gap-3">
                                    <h1 className="text-2xl font-semibold text-gray-900">
                                        You need to create a job first!
                                    </h1>
                                    <h2 className="text-1xl font-semibold text-gray-900">
                                        Set up your job to unlock the power of smart hiring.
                                    </h2>

                                    <p className="text-sm text-gray-700 leading-5.5">
                                        Before proceeding, it's essential to create a job listing.
                                        This will serve as the foundation for managing candidates,
                                        matching talent, and making the most of our smart hiring tools.
                                    </p>

                                    <p className="text-sm text-gray-700 leading-5.5">
                                        Setting up your job is quick and straightforward.
                                        Once your job is created, you'll be able to sort through candidates,
                                        match the right talent to this role, and streamline your recruitment process.
                                    </p>

                                    <p className="text-sm text-gray-700 leading-5.5">
                                        Don't worry – UPFLINX Buddy guides you through the process step by
                                        step, making it simple and intuitive, even if you’re new to AI-driven tools.
                                    </p>
                                </div>
                                <img
                                    src={toAbsoluteUrl('/media/images/avatar-high.png')}
                                    className="dark:hidden max-h-[250px]"
                                    alt="Setup Job Illustration"
                                />
                            </div>
                        </div>
                        <div className="card-footer justify-center">
                            <Link to="/jobs" className="btn btn-link" role="button">
                                Create your first job now!
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { NoJobsContent };
